/**
 * @generated SignedSource<<ac7897c114f338ead9faaae82c09b495>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreatePersonDismissedProjectNotificationMutationInput = {
  projectId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type CreatePersonDismissedProjectNotificationMutation$variables = {
  input: CreatePersonDismissedProjectNotificationMutationInput;
};
export type CreatePersonDismissedProjectNotificationMutation$data = {
  readonly createPersonDismissedProjectNotificationMutation: {
    readonly viewer: {
      readonly personDismissedProjectNotificationIds: ReadonlyArray<string | null> | null;
    } | null;
  } | null;
};
export type CreatePersonDismissedProjectNotificationMutation = {
  variables: CreatePersonDismissedProjectNotificationMutation$variables;
  response: CreatePersonDismissedProjectNotificationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "personDismissedProjectNotificationIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreatePersonDismissedProjectNotificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreatePersonDismissedProjectNotificationMutationPayload",
        "kind": "LinkedField",
        "name": "createPersonDismissedProjectNotificationMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreatePersonDismissedProjectNotificationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreatePersonDismissedProjectNotificationMutationPayload",
        "kind": "LinkedField",
        "name": "createPersonDismissedProjectNotificationMutation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ed2419b7591c161cbe5dbaefd52d5f01",
    "id": null,
    "metadata": {},
    "name": "CreatePersonDismissedProjectNotificationMutation",
    "operationKind": "mutation",
    "text": "mutation CreatePersonDismissedProjectNotificationMutation(\n  $input: CreatePersonDismissedProjectNotificationMutationInput!\n) {\n  createPersonDismissedProjectNotificationMutation(input: $input) {\n    viewer {\n      personDismissedProjectNotificationIds\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "31e0f46ac06c6fccb95b339690234dbb";

export default node;
